// components/BuscadorClienteFactura/ChipsFiltros.jsx
import React from 'react';
import { Box, Chip } from '@mui/material';
import { OPCIONES_FILTROS } from './constants';

const ChipsFiltros = ({ filtrosSeleccionados, onFiltroDelete }) => {
  if (filtrosSeleccionados.length === 0) return null;

  return (
    <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {filtrosSeleccionados.map((filtro) => {
        const opcion = OPCIONES_FILTROS.find(f => f.value === filtro);
        return (
          <Chip
            key={filtro}
            label={opcion?.label.replace(/[👤📋🆔🔢🏠🏙️📞]/g, "").trim()}
            size="small"
            onDelete={() => onFiltroDelete(filtro)}
            color="primary"
            variant="outlined"
          />
        );
      })}
    </Box>
  );
};

export default ChipsFiltros;